const bunyan = require('bunyan');
const PrettyStream = require('bunyan-prettystream');
const _ = require('underscore');
const fs = require('fs');
const path = require('path');

// define tags for underscore micro template system
_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

function createLogger(opts) {
  const streamsConfig = [];

  // Print to stdout
  if (opts.consoleStream) {
    let customStdOut = process.stdout;
    if (opts.prettyStream) {
      // Ahhh so nice..
      customStdOut = new PrettyStream();
      customStdOut.pipe(process.stdout);
    }
    streamsConfig.push({
      stream: customStdOut,
      level: opts.logLevel,
    });
  }

  // Print to file
  let { filePath } = opts;
  if (filePath) {
    filePath = _.template(filePath)({
      app: opts.appName,
      pid: process.pid,
      port: opts.port,
    });

    if (fs.existsSync(path.dirname(filePath))) {
      streamsConfig.push({
        type: 'rotating-file',
        path: filePath,
        level: opts.logLevel,
        period: opts.rotatePeriod,
        count: opts.rotateDepth,
      });
    }
  }

  // RingBuffer
  const ringbuffer = new bunyan.RingBuffer({ limit: opts.ringBufferLimit });
  streamsConfig.push({
    level: 'trace',
    // use 'raw' to get raw log record objects
    type: 'raw',
    stream: ringbuffer,
  });

  // Logger creation
  const logger = bunyan.createLogger({
    name: opts.appName,
    env: opts.env,
    streams: streamsConfig,
    serializers: _.extend(
      {
        error: bunyan.stdSerializers.err,
        err: bunyan.stdSerializers.err,
        req(req) {
          const request = bunyan.stdSerializers.req(req);
          const headers = request.headers || {};
          const excludes = [
            'cookie',
            'x-lc-auth-context', // jwt
            'csrf',
          ];

          request.headers = Object.keys(headers)
            .filter((key) => {
              // If we can't find it, it's not part of the blacklist
              return excludes.indexOf(key) === -1;
            })
            .reduce((acc, key) => {
              acc[key] = headers[key];
              return acc;
            }, {});

          return request;
        },
      },
      opts.serializers
    ),
  });

  // Expose this on our logger singleton
  logger.ringbuffer = ringbuffer;

  // This allows a way for config to not hijack console logs
  if (opts.consoleOverrides && opts.consoleOverrides.forEach) {
    opts.consoleOverrides.forEach((originalLevel) => {
      let level = originalLevel;
      // eslint-disable-next-line no-console
      console[level] = function logLine(...args) {
        if (level === 'log') level = 'debug';
        if (level === 'warn') level = 'debug';

        logger[level](...args);
      };
    });
  }
  return logger;
}

function Logger(opts) {
  return createLogger(opts);
}

module.exports = Logger;

